var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyringe15500661(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3028_2469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.3928 20.0698L60.0607 0.735512C59.2767 -0.0250367 58.0272 -0.0155205 57.2556 0.75674C56.4834 1.52827 56.4739 2.77779 57.2337 3.56176L61.3446 7.67268L50.3595 18.6563L46.2478 14.5454C45.4675 13.7651 44.2019 13.7651 43.4216 14.5454L10.2766 47.6904C9.49629 48.4707 9.49629 49.7363 10.2766 50.5167L18.5306 58.7707L0.610541 76.6915C0.0908214 77.1929 -0.117799 77.9367 0.0652014 78.635C0.248202 79.334 0.793542 79.8801 1.4926 80.0631C2.19166 80.2461 2.93464 80.0375 3.43679 79.5178L21.3569 61.5977L29.6109 69.8517C30.3912 70.6328 31.6569 70.6328 32.4372 69.8517L49.0082 53.2814L49.0111 53.2792L49.0133 53.2763L65.5836 36.7067C66.3639 35.9264 66.3639 34.6608 65.5836 33.8798L61.4727 29.7696L72.4549 18.7852L76.5665 22.8961C77.0687 23.4143 77.8109 23.6208 78.5085 23.4378C79.2069 23.2548 79.7515 22.7102 79.9345 22.0118C80.1175 21.3142 79.911 20.572 79.3928 20.0698ZM55.8839 40.754L49.0119 33.8798C48.2279 33.1199 46.9791 33.1295 46.2068 33.9017C45.4346 34.674 45.4251 35.9228 46.1856 36.7067L53.0576 43.5802L47.5984 49.0395L40.7234 42.166C39.9402 41.4062 38.6907 41.4157 37.9184 42.188C37.1461 42.9602 37.1374 44.209 37.8972 44.993L44.7714 51.865L39.3107 57.3257L32.4372 50.4522C31.935 49.9347 31.1928 49.7276 30.4952 49.9113C29.7976 50.0943 29.253 50.6389 29.0692 51.3365C28.8862 52.0348 29.0934 52.7771 29.6109 53.2792L36.4837 60.152L31.0244 65.612L14.5163 49.1039L44.8351 18.7852L61.3453 35.2932L55.8839 40.754ZM69.6294 15.9589L58.6472 26.9426L53.1857 21.4826L64.1709 10.4997L69.6294 15.9589Z",
    fill: "black",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3028_2469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyringe15500661);
export default __webpack_public_path__ + "static/media/syringe_1550066 1.a379404de9dbc33d9b24c4cea4ecf091.svg";
export { ForwardRef as ReactComponent };